import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import sanitizeHtml from 'sanitize-html';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextBreak } from 'flow-builder/node/textBreak';
import { TextContent } from 'flow-builder/node/textContent';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import ChatInputModal from '../../modals/chatinput';
const translatePayload = (node) => {
    const { nextNodeId } = node.payload;
    return [
        {
            id: uuid(),
            label: 'arrow',
            connection: nextNodeId,
        },
    ];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { nextNodeId: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
export const ChatInputNodeAttributes = {
    iconName: 'input',
    label: 'Chat input',
    color: hexStringToNumber(flowNodeColor.orange),
    translatePayload,
    updateConnection,
    NodeContent: ChatInputNode,
    ActionModal: ChatInputModal,
};
export function ChatInputNode({ node }) {
    const { payload } = node;
    const { message } = payload;
    const sanitizedHtmlMessage = sanitizeHtml(message, {
        /*
         * What's the point of having tags if canvas can't display them?
         */
        allowedTags: [],
    });
    return (_jsx(TextContent, Object.assign({ maxLines: 2 }, { children: useMemo(() => (_jsx(TextBreak, { children: _jsx(Text, { weight: "semibold", text: sanitizedHtmlMessage }) })), [sanitizedHtmlMessage]) })));
}
